import React from 'react';
import { useTranslation } from 'react-i18next';
import BottomNav from '../components/BottomNav';

const PreviewStats = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#FAFAF9] page-container overflow-x-hidden">
      <div className="max-w-sm sm:max-w-md mx-auto p-4 sm:p-6 space-y-6">
        <div className="bg-inherit rounded-2xl p-6 sm:p-8 shadow-sm w-full">
          <div className="text-center pt-8 pb-7">
            <div className="font-manrope font-semibold text-[48px] leading-[1.1] tracking-[-0.5px] text-[#111]">18</div>
            <div className="font-manrope font-medium text-[18px] text-[#222] mt-1">{t('stats.days')}</div>
            <div className="font-manrope font-medium text-[20px] text-[#000] tracking-[-0.2px] mt-2">{t('stats.present')}</div>
            <div className="font-manrope font-normal text-[13px] text-[#888] mt-3">{t('stats.lastDays', { count: 30 })}</div>
          </div>
        </div>

        <div className="bg-inherit rounded-2xl p-6 shadow-sm w-full">
          <div className="flex items-center gap-3 mb-4">
            <h2 className="text-sm font-semibold uppercase tracking-widest text-stone-500">{t('stats.categories')}</h2>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between items-center"><span className="text-sm text-stone-600">{t('categories.presence')}</span><span className="text-sm text-stone-500">12</span></div>
            <div className="flex justify-between items-center"><span className="text-sm text-stone-600">{t('categories.connection')}</span><span className="text-sm text-stone-500">3</span></div>
          </div>
        </div>
      </div>
      <BottomNav currentPage="stats" />
    </div>
  );
};

export default PreviewStats;
